import {useState, useEffect, useCallback, useRef} from 'react';

// Custom hook to handle infinite scroll table business logic
export const useInfiniteScrollTable = (products, itemsPerPage = 10) => {
  const [displayedProducts, setDisplayedProducts] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [isLoading, setIsLoading] = useState(false);
  const tableContainerRef = useRef(null);

  // Initialize displayed products
  useEffect(() => {
    if (products.length > 0) {
      setDisplayedProducts(products.slice(0, itemsPerPage));
      setCurrentPage(1);
    } else {
      setDisplayedProducts([]);
      setCurrentPage(1);
    }
  }, [products, itemsPerPage]);

  const loadMoreProducts = useCallback(() => {
    if (isLoading || displayedProducts.length >= products.length) return;

    setIsLoading(true);

    setTimeout(() => {
      const nextPage = currentPage + 1;
      const startIndex = currentPage * itemsPerPage;
      const endIndex = startIndex + itemsPerPage;
      const newProducts = products.slice(startIndex, endIndex);

      if (newProducts.length > 0) {
        setDisplayedProducts((prev) => [...prev, ...newProducts]);
        setCurrentPage(nextPage);
      }
      setIsLoading(false);
    }, 100);
  }, [
    currentPage,
    displayedProducts.length,
    isLoading,
    products,
    itemsPerPage
  ]);

  const handleScroll = useCallback(
    (e) => {
      const {scrollTop, scrollHeight, clientHeight} = e.target;

      // Load more when user scrolls to bottom (with 50px threshold)
      if (scrollHeight - scrollTop <= clientHeight + 50) {
        loadMoreProducts();
      }
    },
    [loadMoreProducts]
  );

  return {
    displayedProducts,
    isLoading,
    hasMoreData: displayedProducts.length < products.length,
    totalProducts: products.length,
    tableContainerRef,
    handleScroll,
    itemsPerPage
  };
};
